export default "__VITE_PUBLIC_ASSET__a0680c75__"